(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manuzen-festzen-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mz-festzen-banner')) {
    customElements.define('mz-festzen-banner', class extends HTMLElement {
      connectedCallback() {
        this.start = Date.parse(this.dataset.start);
        this.end = Date.parse(this.dataset.end);
        this.editor = this.dataset.editor === 'true';
        this.link = this.querySelector('[data-discount-link]');
        this.timer = this.querySelector('[data-timer]');
        this.updateLink = this.updateLink.bind(this);
        this.refresh = this.refresh.bind(this);
        this.updateLink();
        this.addEventListener('pointerdown', this.updateLink);
        this.addEventListener('focusin', this.updateLink);
        this.addEventListener('click', this.updateLink);
        document.addEventListener('visibilitychange', this.refresh);
        this.interval = setInterval(this.refresh, 30000);
        this.refresh();
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        this.removeEventListener('pointerdown', this.updateLink);
        this.removeEventListener('focusin', this.updateLink);
        this.removeEventListener('click', this.updateLink);
        document.removeEventListener('visibilitychange', this.refresh);
      }
      updateLink() {
        if (!this.link) return;
        const current = new URL(window.location.href);
        const target = new URL(this.link.href, window.location.origin);
        if (target.origin !== current.origin) return;
        const returnTo = current.pathname + current.search + current.hash;
        target.searchParams.set('redirect', returnTo);
        this.link.href = target.pathname + target.search;
      }
      refresh() {
        const now = Date.now();
        const valid = Number.isFinite(this.start) && Number.isFinite(this.end) && this.end > this.start;
        const active = valid && now >= this.start && now < this.end;
        if (!this.editor && !active) {
          this.hidden = true;
          if (!valid || now >= this.end) clearInterval(this.interval);
          return;
        }
        this.hidden = false;
        if (!valid) {
          if (this.timer) this.timer.hidden = true;
          return;
        }
        if (this.timer) this.timer.hidden = !active;
        if (!active) return;
        const seconds = Math.max(0, Math.ceil((this.end - now) / 1000));
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60) };
        Object.entries(values).forEach(([key, value]) => {
          const node = this.querySelector('[data-' + key + ']');
          if (node) node.textContent = key === 'days' ? String(value) : String(value).padStart(2, '0');
        });
        const progress = Math.max(0, Math.min(100, (now - this.start) / (this.end - this.start) * 100));
        this.style.setProperty('--mz-fz-progress', progress.toFixed(3) + '%');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
